/**
 * @prettier
 * @flow
 */
export function removeNulls<T: Object | Array<any>>(obj: T): T {
    if (Array.isArray(obj)) {
        for (let i = 0; i < obj.length; i++) {
            if (obj[i] === null || obj[i] === undefined) {
                obj.splice(i, 1);
                i--;
            } else {
                removeNulls(obj[i]);
            }
        }
        return obj;
    }
    Object.keys(obj).forEach(key => {
        if (obj[key] === null) {
            delete obj[key];
            return;
        }
        if (obj[key] === undefined) {
            delete obj[key];
            return;
        }
        if (obj[key] && typeof obj[key] === 'object') {
            removeNulls(obj[key]);
        } else if (obj[key] === null) {
            delete obj[key];
        } else if (obj[key] === undefined) {
            delete obj[key];
        }
    });
    return obj;
}
